import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export default function RequirePermission({ code, anyOf, rootOnly = false, children }) {
  const location = useLocation();
  const rawUser = typeof localStorage !== 'undefined' ? localStorage.getItem('user') : null;

  if (!rawUser) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  let permisos = [];
  let isSuperadmin = false;
  try {
    const user = JSON.parse(rawUser);
    permisos = Array.isArray(user?.permisos) ? user.permisos : [];
    isSuperadmin = user?.rol_id === 1;
  } catch {
    return <Navigate to="/" replace />;
  }

  // rootOnly: pantallas ultra sensibles (ej. credenciales de integraciones externas).
  // No hay bypass por permiso individual — solo el superadmin (rol_id = 1) entra.
  if (rootOnly) {
    if (!isSuperadmin) return <Navigate to="/dashboard/view_dashboard" replace />;
    return children;
  }

  const codes = permisos.map(p => p.codigo);
  const needed = Array.isArray(anyOf) && anyOf.length ? anyOf : (code ? [code] : []);
  const ok = isSuperadmin || needed.length === 0 || needed.some(c => codes.includes(c));

  if (!ok) {
    return <Navigate to="/dashboard/view_dashboard" replace />;
  }

  return children;
}

